export const timeDuration = () => {
	const durations = [];
	for (let minutes = 30; minutes <= 1440; minutes += 30) {
		const hours = Math.floor(minutes / 60);
		const remainingMinutes = minutes % 60;
		const duration = {
			key:
				hours > 0
					? `${hours} hour${hours > 1 ? "s" : ""}${remainingMinutes > 0 ? `, ${remainingMinutes} min` : ""}`
					: `${remainingMinutes} min`,
			value: minutes,
		};
		durations.push(duration);
	}
	return durations;
};
